module.exports = __webpack_public_path__ + "static/media/Cabin.svg";